import { useEffect } from 'react';
import { Paragraph } from 'components/Base/Typography';
import { Spinner } from 'components/Base/Spinner';
import { useGetAnimalByIdQuery } from 'redux/apiSlice/animal.slice';
import { Colors, FontWeights } from 'core/CssVariables';
import useAnimalFieldVisibility from 'hooks/useAnimalFieldVisibility';
import AnimalForm from './components/AnimalForm';
import { TCreateAnimalFormProps } from './CreateAnimalForm.types';

const CreateAnimalForm = ({
  animalId,
  formObj,
  actionType,
  animalType,
  hasActiveResidency,
  residencyMoveInDate,
  tenantResidencyId,
}: TCreateAnimalFormProps) => {
  const { form } = formObj;
  const {
    data: animalData,
    isLoading,
    isSuccess,
  } = useGetAnimalByIdQuery(animalId, {
    skip: !animalId,
  });
  // Held behind the same spinner as the animal itself. The visibility query cannot start until this
  // component has a residency id, so painting first would show the hidden fields and the documents
  // section for a frame and then take them away. RTK Query's shared cache spares the second
  // subscriber, not the first paint.
  const { isLoading: visibilityLoading } =
    useAnimalFieldVisibility(tenantResidencyId);

  useEffect(() => {
    if (isSuccess) {
      form.resetFields();
    }
  }, [isSuccess]);

  return (
    <div style={isLoading ? { height: '100vh' } : {}}>
      {visibilityLoading || (animalId && (isLoading || !animalData)) ? (
        <Spinner size="default" centered width={40} />
      ) : (
        <>
          <Paragraph
            fontWeight={FontWeights.Medium}
            color={Colors.Black}
            className="mb-2"
          >
            Upload animal picture
          </Paragraph>
          <AnimalForm
            animalType={animalData?.type?.value || animalType}
            animalData={animalData}
            actionType={actionType}
            formObj={formObj}
            hasActiveResidency={hasActiveResidency}
            residencyMoveInDate={residencyMoveInDate}
            tenantResidencyId={tenantResidencyId}
          />
        </>
      )}
    </div>
  );
};

export default CreateAnimalForm;
